import React from "react";
import ViewDocs from "./viewDocs";

const DockerfileSelect = ({ newDocker, dockerUuid, dockerArray, handleChange }) => {   
    return (
        <>
            <div className="input-field">
                <div className="top-input">
                    {newDocker ? "New " : ""}Docker Environment
                    <div>
                        <ViewDocs path={'/account-settings'} name={"Upload"}/>
                    </div>
                </div>
                <select className="metric-select docker-select" value={dockerUuid} onChange={(e) => {handleChange(e.target.value)}}>
                    <option key={""} value={""}>
                        None
                    </option>
                    {
                        dockerArray?.map((dockerfile) => {
                            return (
                                <option key={dockerfile.dockerUuid} value={dockerfile.dockerUuid}>
                                    {dockerfile.name}
                                </option>
                            )                    
                        })
                    }
                </select>
            </div>
        </>
    );
}

export default DockerfileSelect;